import React from 'react'
import { useSelector } from 'react-redux'
import { setUserUIScreen } from '../../../store/ui/ui.actions'
import { USER_SCREENS } from '../../../store/ui/ui.constants'
import { selectIsUserScreenDefault } from '../../../store/ui/ui.selectors'
import SVGIcon from '../../svg/SVGIcon'
import { useAction } from '../../utils/react-redux'
import useEventCallback from '../../utils/useEventCallback'
import s from './UserScreenHeader.less'
import classNames from 'classnames'

const UserScreenHeader = ({ children, rightChildren, noBar = false }) => {
  const isDefaultScreen = useSelector(selectIsUserScreenDefault)
  const execSetUserUIScreen = useAction(setUserUIScreen)

  const onBack = useEventCallback(() => execSetUserUIScreen(USER_SCREENS.default))

  return (
    <div className={classNames(s.root, noBar && s.noBar)}>
      <div className={s.left}>
        {!isDefaultScreen && (
          <div className={s.back} onClick={onBack}>
            <SVGIcon icon={'chevron'} />
          </div>
        )}
      </div>
      <div className={`${s.title}`}>{children}</div>
      <div className={s.right}>{rightChildren}</div>
    </div>
  )
}

export default UserScreenHeader
